import React from "react";
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Πολιτική Επιστροφών - Ferupen Barbershop</title>
        <meta
          name="description"
          content="Πολιτική επιστροφών και επιστροφής χρημάτων του Ferupen Barbershop"
        />
      </Helmet>

      <div className="policy-container">
        <h1>Πολιτική Επιστροφών και Επιστροφής Χρημάτων</h1>
        <p className="policy-date">Τελευταία ενημέρωση: 15 Ιανουαρίου 2025</p>

        <h2>1. Επισκόπηση</h2>
        <p>
          Στο Ferupen Barbershop, επιδιώκουμε την πλήρη ικανοποίησή σας. Εάν δεν
          είστε απόλυτα ευχαριστημένοι με την αγορά σας, είμαστε εδώ να
          βοηθήσουμε. Αυτή η πολιτική περιγράφει τους όρους και τις προϋποθέσεις
          για επιστροφές και επιστροφή χρημάτων.
        </p>

        <h2>2. Περίοδος Επιστροφής</h2>
        <h3>2.1 Χρονοδιάγραμμα</h3>
        <p>
          Έχετε 30 ημέρες από την ημερομηνία παραλαβής του προϊόντος για να
          ξεκινήσετε επιστροφή. Μετά από αυτήν την περίοδο, δυστυχώς δεν
          μπορούμε να προσφέρουμε επιστροφή χρημάτων ή ανταλλαγή.
        </p>

        <h3>2.2 Κατάσταση Προϊόντος</h3>
        <p>Για να είναι επιλέξιμο για επιστροφή, το προϊόν σας πρέπει:</p>
        <ul>
          <li>Να είναι στην αρχική του κατάσταση και συσκευασία</li>
          <li>Να μην έχει χρησιμοποιηθεί ή φορεθεί</li>
          <li>Να έχει όλες τις ετικέτες του</li>
          <li>Να είναι στην ίδια κατάσταση που το λάβατε</li>
          <li>Να συνοδεύεται από απόδειξη αγοράς ή τιμολόγιο</li>
        </ul>

        <h2>3. Μη Επιστρέψιμα Προϊόντα</h2>
        <p>
          Ορισμένα προϊόντα δεν μπορούν να επιστραφούν για λόγους υγιεινής και
          ασφάλειας:
        </p>
        <ul>
          <li>Προϊόντα περιποίησης που έχουν ανοιχτεί ή χρησιμοποιηθεί</li>
          <li>Προϊόντα προσωπικής φροντίδας</li>
          <li>Προϊόντα σε προσφορά ή εκπτωτικά είδη</li>
          <li>Προϊόντα που έχουν παραγγελθεί ειδικά για εσάς</li>
          <li>Ηλεκτρονικά προϊόντα που έχουν ενεργοποιηθεί</li>
        </ul>

        <h2>4. Διαδικασία Επιστροφής</h2>
        <h3>4.1 Έναρξη Επιστροφής</h3>
        <p>
          Για να ξεκινήσετε επιστροφή, παρακαλούμε επικοινωνήστε μαζί μας στο
          <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a> ή στο
          +302299022996 με τον αριθμό παραγγελίας σας και το προϊόν που
          επιθυμείτε να επιστρέψετε.
        </p>

        <h3>4.2 Έγκριση Επιστροφής</h3>
        <p>
          Αφού λάβουμε το αίτημά σας, θα σας στείλουμε οδηγίες για το πώς και
          πού να στείλετε το πακέτο σας. Τα προϊόντα που επιστρέφονται χωρίς
          προηγούμενη εξουσιοδότηση δεν θα γίνουν δεκτά.
        </p>

        <h3>4.3 Αποστολή Επιστροφής</h3>
        <p>
          Θα πρέπει να αναλάβετε το κόστος αποστολής για την επιστροφή του
          προϊόντος σας, εκτός εάν το προϊόν είναι ελαττωματικό ή εάν έχουμε
          κάνει λάθος στην αποστολή.
        </p>

        <h2>5. Επιστροφή Χρημάτων</h2>
        <h3>5.1 Επεξεργασία</h3>
        <p>
          Μόλις παραλάβουμε και επιθεωρήσουμε την επιστροφή σας, θα σας
          ειδοποιήσουμε αν η επιστροφή χρημάτων έχει εγκριθεί. Εάν εγκριθεί, η
          επιστροφή χρημάτων θα επεξεργαστεί αυτόματα στην αρχική μέθοδο
          πληρωμής.
        </p>

        <h3>5.2 Χρονοδιάγραμμα</h3>
        <p>
          Μπορεί να χρειαστούν 5-10 εργάσιμες ημέρες για να εμφανιστεί η
          επιστροφή χρημάτων στον λογαριασμό σας, ανάλογα με την τράπεζα ή τον
          πάροχο πληρωμών σας.
        </p>

        <h3>5.3 Μερική Επιστροφή Χρημάτων</h3>
        <p>
          Μερική επιστροφή χρημάτων μπορεί να χορηγηθεί σε περιπτώσεις όπως:
        </p>
        <ul>
          <li>Προϊόντα με εμφανείς σημάδια χρήσης</li>
          <li>Προϊόντα χωρίς την αρχική συσκευασία</li>
          <li>Προϊόντα που επιστρέφονται πέραν της περιόδου επιστροφής</li>
          <li>Προϊόντα που δεν βρίσκονται στην αρχική τους κατάσταση</li>
        </ul>

        <h2>6. Ανταλλαγές</h2>
        <h3>6.1 Διαδικασία Ανταλλαγής</h3>
        <p>
          Εάν θέλετε να ανταλλάξετε ένα προϊόν για διαφορετικό μέγεθος, χρώμα ή
          άλλο προϊόν, παρακαλούμε επικοινωνήστε μαζί μας. Οι ανταλλαγές
          υπόκεινται σε διαθεσιμότητα.
        </p>

        <h3>6.2 Κόστος Ανταλλαγής</h3>
        <p>
          Δεν χρεώνουμε για ανταλλαγές, αλλά μπορεί να σας ζητηθεί να καλύψετε
          τα έξοδα αποστολής και για τις δύο κατευθύνσεις.
        </p>

        <h2>7. Ελαττωματικά ή Λανθασμένα Προϊόντα</h2>
        <h3>7.1 Αναφορά Προβλήματος</h3>
        <p>
          Εάν λάβατε ελαττωματικό ή λανθασμένο προϊόν, επικοινωνήστε μαζί μας
          αμέσως εντός 48 ωρών από την παραλαβή με φωτογραφίες του προϊόντος και
          της συσκευασίας.
        </p>

        <h3>7.2 Επίλυση</h3>
        <p>Για ελαττωματικά ή λανθασμένα προϊόντα, θα:</p>
        <ul>
          <li>Αντικαταστήσουμε το προϊόν χωρίς επιπλέον κόστος</li>
          <li>Προσφέρουμε πλήρη επιστροφή χρημάτων</li>
          <li>Καλύψουμε όλα τα έξοδα αποστολής</li>
        </ul>

        <h2>8. Ζημιά κατά τη Μεταφορά</h2>
        <p>Εάν το προϊόν σας φτάσει κατεστραμμένο, παρακαλούμε:</p>
        <ul>
          <li>Μην αποδεχτείτε το πακέτο εάν φαίνεται σοβαρά κατεστραμμένο</li>
          <li>Τραβήξτε φωτογραφίες της ζημιάς και της συσκευασίας</li>
          <li>Επικοινωνήστε μαζί μας εντός 48 ωρών</li>
          <li>Διατηρήστε όλα τα υλικά συσκευασίας</li>
        </ul>

        <h2>9. Ακυρώσεις Παραγγελίας</h2>
        <h3>9.1 Πριν την Αποστολή</h3>
        <p>
          Μπορείτε να ακυρώσετε την παραγγελία σας για πλήρη επιστροφή χρημάτων
          πριν από την αποστολή επικοινωνώντας μαζί μας το συντομότερο δυνατό.
        </p>

        <h3>9.2 Μετά την Αποστολή</h3>
        <p>
          Αφού αποσταλεί η παραγγελία, ισχύει η τυπική πολιτική επιστροφών μας.
        </p>

        <h2>10. Διεθνείς Επιστροφές</h2>
        <p>
          Για διεθνείς παραγγελίες, οι πελάτες είναι υπεύθυνοι για τα έξοδα
          επιστροφής και τυχόν τελωνειακούς φόρους. Συνιστούμε τη χρήση
          μεταφορικής υπηρεσίας με δυνατότητα παρακολούθησης.
        </p>

        <h2>11. Επικοινωνία</h2>
        <p>Για ερωτήσεις σχετικά με επιστροφές ή επιστροφές χρημάτων:</p>
        <p>
          Email: <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
          <br />
          Τηλέφωνο: +302299022996
          <br />
          Διεύθυνση: Οδός Αντωνόπουλος 38, 51842 Μαρκόπουλο Μεσογαίας, Ελλάδα
          <br />
          Ωράριο: Δευτέρα - Παρασκευή, 09:00 - 20:00
          <br />
          ΑΦΜ: 87657353
        </p>

        <h2>12. Αλλαγές στην Πολιτική</h2>
        <p>
          Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτήν την πολιτική επιστροφών
          ανά πάσα στιγμή. Οι αλλαγές θα δημοσιεύονται στην ιστοσελίδα μας και
          θα ισχύουν αμέσως.
        </p>
      </div>
    </>
  );
}

export default RefundPolicy;
